import * as GETTERS from '@/store/constants/getters.js';

export const getters = {
    [GETTERS.QUICK_SEARCH_BY_HASH](state) {
        return (hash) => state[hash];
    },
    [GETTERS.ALL_QUICK_SEARCHES](state) {
        return Object.values(state);
    },
};
